import { PublicationType } from 'common/client-data-types/publication'
import { Block } from 'common/client-data-types/blocks'

export interface VideoData {
    present: boolean
    count: number
    types: {
        heroVideo: boolean
        inlineVideo: boolean
    }
}

export const getPublicationPageProperties = (article: PublicationType) => {
    const heroVideoPresent = !!article.heroVideo

    const isInlineVideo = (contentItem: Block) =>
        contentItem.kind === 'inline' && contentItem.inlineKind === 'video'

    const videoCount =
        article.kind === 'article' && article.content
            ? article.content.reduce((acc, val) => (isInlineVideo(val) ? acc + 1 : acc), 0)
            : 0

    const count = (heroVideoPresent ? 1 : 0) + videoCount

    const videoData: VideoData = {
        present: count > 0,
        count: (heroVideoPresent ? 1 : 0) + videoCount,
        types: {
            heroVideo: heroVideoPresent,
            inlineVideo: !!videoCount,
        },
    }

    if (article.kind === 'article') {
        videoData.present = heroVideoPresent || videoData.types.inlineVideo

        return {
            primaryTopic: article.primaryTopic,
            secondaryTopics: article.secondaryTopics,
            articleKind: article.kind,
            isSponsored: article.isSponsored,
            source: article.source,
            byline: article.byline,
            title: article.heading,
            publicationDate: article.publicationDate,
            isPremium: article.isPremium,
            video: videoData,
            liveBlog: {
                isLive: !!article.isLive,
                isPresent: !!article.blogIsPresent,
            },
            oovvuuRecommendationsLoaded: article.hasOovvuuRecommendations === true,
        }
    }

    return {
        primaryTopic: article.primaryTopic,
        secondaryTopics: article.secondaryTopics,
        articleKind: article.kind,
        source: article.source,
        publicationDate: article.publicationDate,
    }
}
